"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientInquiryTemplate = void 0;
exports.ClientInquiryTemplate = `<body style="font-family: 'Arial', 'Helvetica', sans-serif; font-size: 16px; font-weight: 400;">
    <p>
    {{greeting}}
    </p>
    <br/>
    <table cellspacing="0" style="border: 1px solid #D9D8D7; border-collapse: collapse;">
        <tr>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-right: 1px solid #979797; width: 110px; vertical-align: top;">Name:</td>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-left: 1px solid #979797; vertical-align: top;">{{fullName}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-right: 1px solid #979797; width: 110px; vertical-align: top;">Email address:</td>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-left: 1px solid #979797; vertical-align: top;">{{emailAddress}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-right: 1px solid #979797; width: 110px; vertical-align: top;">Message:</td>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-left: 1px solid #979797; vertical-align: top;">{{message}}</td>
        </tr>
        <tr>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-right: 1px solid #979797; width: 110px; vertical-align: top;">Additional comments from client:</td>
            <td style="border: 1px solid #D9D8D7; padding: 8px; border-left: 1px solid #979797; vertical-align: top;">{{comments}}</td>
        </tr>
    </table>
    <br/>
    <p>Thank you,</p>
    <br/>
    <p style="color: #57595c; font-size: 13px;">
        <b>For advisor and field leader use only</b>. Not for inspection by, distribution or quotation to the general public.
    </p>
    <p style="color: #57595c; font-size: 13px;">
        <b>Investment products are not insured by the FDIC, NCUA or any federal agency, are not deposits or obligations of, or guaranteed by any financial institution, and involve investment risks including possible loss of principal and fluctuation in value.</b>
    </p>
    <p style="color: #57595c; font-size: 13px;">
        Securities offered by Ameriprise Financial Services, LLC. Member FINRA and SIPC.<br/>
        &copy; {{year}} Ameriprise Financial, Inc. All rights reserved.
    </p>
</body>`;
